import React from "react";
import { Briefcase, Calendar, GraduationCap, ShieldCheck } from "lucide-react";
import { useSelector } from "react-redux";

const services = [
  {
    id: 1,
    title: { fr: "Gestion des congés", ar: "إدارة الإجازات" },
    description: { fr: "Demandez et suivez vos congés facilement.", ar: "اطلب وتابع إجازاتك بسهولة." },
    icon: <Calendar className="text-green-600 size-10" />,
  },
  {
    id: 2,
    title: { fr: "Paie & Avantages", ar: "الرواتب والمزايا" },
    description: { fr: "Accédez à vos fiches de paie et à vos avantages sociaux.", ar: "وصول إلى كشوف الرواتب والمزايا الاجتماعية." },
    icon: <Briefcase className="text-green-600 size-10" />,
  },
  {
    id: 3,
    title: { fr: "Formation & Développement", ar: "التدريب والتطوير" },
    description: { fr: "Explorez des opportunités de formation et de perfectionnement.", ar: "استكشاف فرص التدريب والتطوير." },
    icon: <GraduationCap className="text-green-600 size-10" />,
  },
  {
    id: 4,
    title: { fr: "Sécurité & Bien-être", ar: "السلامة والرفاهية" },
    description: { fr: "Accédez aux ressources pour assurer votre bien-être au travail.", ar: "الوصول إلى الموارد لضمان رفاهيتك في العمل." },
    icon: <ShieldCheck className="text-green-600 size-10" />,
  },
];

function EmployeeServices() {
  const langue = useSelector((state) => state.langue.value);

  return (
    <div className="mx-auto w-full p-6 bg-gray-300">
      <h1 id="titre" className="text-3xl font-bold text-center mb-6 text-green-800">
        {langue === "fr" ? "Services pour les employés" : "الخدمات للموظفين"}
      </h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {services.map((service) => (
          <div key={service.id} className="bg-gray-200 p-4 shadow-md rounded-lg text-center">
            <div className="mb-3 flex justify-center">{service.icon}</div>
            <h2 className="text-lg font-semibold">
              {langue === "fr" ? service.title.fr : service.title.ar}
            </h2>
            <p className="text-gray-500">
              {langue === "fr" ? service.description.fr : service.description.ar}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default EmployeeServices;
